export const testMode = import.meta.env.DEV;